























































import { Component, Mixins, Watch } from 'vue-property-decorator'
import moment from 'moment'
import AuthService from '@/services/auth-service'
import SnackbarService from '@/services/snackbar-service'
@Component({
  components: {},
})
export default class Payment extends Mixins(AuthService, SnackbarService) {
  PAYPAL_BUTTON_ID = 'paypal-button-container'
  offset = 0
  moment: any
  amountMonth = -1
  paymentOptions = [
    { text: '1 Month', value: 1 },
    { text: '2 Month', value: 2 },
    { text: '6 Month', value: 6 },
    { text: '12 Month', value: 12 },
  ]
  initPaypalReady = false

  created() {
    this.moment = moment
    this.offset = new Date().getTimezoneOffset()
    const url =
      'https://www.paypal.com/sdk/js?client-id=ATyeBQ50UUFMx4ixtRb3JmvgmndtlohVWMYqcPURfDFch6A5-mKYxt_20giVgGp8fzUlyxLQ2OFM1mbr'
    this.loadScript(url, this.setInitPaypalReady)
  }

  setInitPaypalReady() {
    this.initPaypalReady = true
  }

  @Watch('amountMonth')
  initPayPalButton() {
    console.log('initpaypal called')
    this.removeAddEmptyButton()
    const itemPriceDesc = this.getItemPriceDesc()
    const paypal = (window as any).paypal
    paypal
      .Buttons({
        style: {
          shape: 'rect',
          color: 'blue',
          height: 25,
          layout: 'vertical',
          label: 'buynow',
          fundingicons: 'true',
        },
        createOrder: (data, actions) => {
          return actions.order.create({
            purchase_units: [
              {
                description: itemPriceDesc.desc,
                amount: {
                  currency_code: 'USD',
                  value: itemPriceDesc.price,
                  breakdown: {
                    item_total: {
                      currency_code: 'USD',
                      value: itemPriceDesc.price,
                    },
                    shipping: {
                      currency_code: 'USD',
                      value: 0,
                    },
                    tax_total: {
                      currency_code: 'USD',
                      value: 0,
                    },
                  },
                },
                items: [
                  {
                    name: itemPriceDesc.desc,
                    unit_amount: {
                      currency_code: 'USD',
                      value: itemPriceDesc.price,
                    },
                    quantity: 1,
                  },
                ],
              },
            ],
          })
        },
        onApprove: (data, actions) => {
          this.$store.state.loading = true
          return actions.order.capture().then(details => {
            const payment = JSON.stringify(details)
            this.savePayment(payment, this.amountMonth)
              .then((res: any) => {
                this.getAccount(this.$store.state.user.account_id)
                  .then((res: any) => {
                    this.removeButton()
                    this.amountMonth = -1
                    this.$store.state.account = res.data
                  })
                  .finally(() => {
                    this.$store.state.loading = false
                  })
                this.notify({ text: 'Payment successfull', type: 'success' })
              })
              .catch((error: any) => {
                this.notify({
                  text:
                    'An error occurred during the payment process. Please contact inventarioganadero@gmail.com',
                  timeout: 20000,
                })
                this.$store.state.loading = false
              })
          })
        },
        onError: err => {
          this.notify({
            text:
              'An error occurred during the payment process. Please contact inventarioganadero@gmail.com',
            timeout: 20000,
          })
        },
      })
      .render('#paypal-button-container')
  }

  loadScript(url, callback) {
    const script: any = document.createElement('script')
    script.type = 'text/javascript'
    if (script.readyState) {
      // only required for IE <9
      script.onreadystatechange = function() {
        if (
          script.readyState === 'loaded' ||
          script.readyState === 'complete'
        ) {
          script.onreadystatechange = null
          callback()
        }
      }
    } else {
      script.onload = function() {
        callback()
      }
    }

    script.src = url
    document.getElementsByTagName('head')[0].appendChild(script)
  }

  getItemPriceDesc() {
    if (this.amountMonth === 1) {
      return { price: 10, desc: '1 Month' }
    } else if (this.amountMonth === 2) {
      return { price: 18, desc: '2 Months' }
    } else if (this.amountMonth === 6) {
      return { price: 50, desc: '6 Months' }
    } else if (this.amountMonth === 12) {
      return { price: 110, desc: '12 Months' }
    }
    throw Error()
  }

  removeButton() {
    const oldButton = document.getElementById(this.PAYPAL_BUTTON_ID)
    if (oldButton) {
      oldButton.remove()
    }
  }

  removeAddEmptyButton() {
    this.removeButton()
    const wrapper = document.getElementById('paypal-button-wrapper')
    const newButton = document.createElement('div')
    newButton.id = this.PAYPAL_BUTTON_ID
    wrapper.appendChild(newButton)
  }
}
